module.exports = __webpack_public_path__ + "static/media/alarm.3e0075a7.svg";